const _excluded = ["title", "titleId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSnowflakeQuickmenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.63 13.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.6px;}")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "snowflake_quickmenu") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "\u0428\u0430\u0440_2",
    "data-name": "\u0428\u0430\u0440 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\u0421\u043B\u043E\u0439_1",
    "data-name": "\u0421\u043B\u043E\u0439 1"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "0 6.48 11.46 6.48 14.63 6.48"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 13.67,
    y1: 4.37,
    x2: 11.51,
    y2: 6.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 13.67,
    y1: 8.65,
    x2: 11.51,
    y2: 6.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1.1,
    y1: 8.65,
    x2: 3.26,
    y2: 6.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1.1,
    y1: 4.37,
    x2: 3.26,
    y2: 6.53
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "3.3 0.25 9.36 9.98 11.03 12.67"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 12.32,
    y1: 10.74,
    x2: 9.34,
    y2: 10.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 8.69,
    y1: 13,
    x2: 9.39,
    y2: 10.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 2.05,
    y1: 2.33,
    x2: 5.02,
    y2: 3.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 5.67,
    y1: 0.07,
    x2: 4.98,
    y2: 3.05
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "11.2 0.25 5.14 9.98 3.46 12.67"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 2.18,
    y1: 10.74,
    x2: 5.15,
    y2: 10.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 5.8,
    y1: 13,
    x2: 5.11,
    y2: 10.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 12.45,
    y1: 2.33,
    x2: 9.47,
    y2: 3.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 8.82,
    y1: 0.07,
    x2: 9.52,
    y2: 3.05
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnowflakeQuickmenu);
export default __webpack_public_path__ + "static/media/snowflake_quickmenu.b088fef2be53c730f1afcdb7070698c5.svg";
export { ForwardRef as ReactComponent };